<template>
    <div class="animated fadeIn">
      <b-button
        type="button"
        size="sm"
        variant="primary"
        v-on:click="addNews"
        :disabled="disabled"
      ><i class="fa fa-plus" ></i>Add
      </b-button>
    </div>
</template>
<script>
    import {News} from "../../../models/News/News";
    import router from "../../../router";
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";

    const NewsRepo = RepositoryFactory.get('news');

    export default {
        name: 'news-add-btn',
        props: {
          news: {
            type: Object,
            default: new News(),
          },
          disabled: {
            type: Boolean,
            default: false,
          },
        },
        methods: {
          addNews() {
            this.$emit('click', true)
            this.disabled = true
            let payload = {
              name: this.news.name,
              content: this.news.content,
              publishedAt: this.$moment(this.news.publishedAt).format('YYYY-MM-DD')+'T00:00:00+01:00',
              isAction: this.news.isAction,
              externalLink: this.news.externalLink,
              videoLink: this.news.videoLink,
              categories: []
            }

            this.news.categories.forEach(
              value => {
                payload.categories.push({category: value})
              }
            )

            NewsRepo
              .createNews(payload)
              .then(
                response =>
                  (
                    router.push({name: 'news-item', params: {newsId: response.data.data.id}})
                  )
              )
              .catch(
                response => (
                  this.returnErrors(response)
                )
              )
          },
          returnErrors(response) {
            this.$emit('click', false)
            handleErrors(response).forEach(
              value => {
                this.flash(value,'error')
              }
            )
          },
        },
    }
</script>
